<template>
  <div>
    <section-title
      content="Datos de Destrezas y otra información recopilada"
      has-line
    />

    <div v-if="!isReadOnly" class="my-3">
      <div class="col-md-8 d-flex align-items-end">
        <custom-drop-down
          v-model="skillSelected"
          class="w-80"
          clearable
          fieldkey="id"
          fieldname="name"
          label="Añadir Destreza:"
          :options="availableSkills"
        />
        <action-button
          class="ml-2"
          :disabled="!skillSelected"
          i="fas fa-file-plus"
          variant="success"
          @click="addSkill()"
        >
          Añadir
        </action-button>
      </div>
      <validation-provider
        ref="skills"
        v-slot="{ errors }"
        name="skills"
        :rules="model.skills.length > 0 ? '' : 'required'"
      >
        <error
          v-if="errors[0]"
          class="m-3"
          message="Añada al menos una destreza"
          variant="no-border"
        />
      </validation-provider>
    </div>

    <div class="row my-2">
      <div class="col-12 d-flex justify-content-lg-end">
        <action-button
          class="outline-dark-gray"
          :i="anyCollapseOpen ? 'fal fa-compress-alt' : 'fal fa-expand-alt'"
          :text="anyCollapseOpen ? 'Colapsar Todo' : 'Expandir Todo'"
          @click="expandAll(!anyCollapseOpen)"
        />
      </div>
    </div>

    <skill-collapse
      v-for="item in model.skills"
      :key="item.id"
      :description="item.description"
      :disabled="isReadOnly"
      :title="item.name"
      :value="collapseState[item.id]"
      @input="updateCollapseState(item.id, $event)"
      @remove="remove(item)"
    >
      <skill-content
        :answers="model.answers"
        :is-read-only="isReadOnly"
        :value="item"
      />
    </skill-collapse>
  </div>
</template>

<script>
import storeMixin from '@/shared/mixins/storeGenerator';
import alertMixin from '@/mixins/alert.mixin.js';
import SkillCollapse from './SkillCollapse.vue';
import SectionTitle from '@/shared/components/SectionTitle.vue';
import SkillContent from './SkillContent.vue';
import Error from 'custom-error';
import CustomDropDown from 'custom-drop-down';

export default {
  name: 'Skills',
  components: {
    SkillCollapse,
    SectionTitle,
    SkillContent,
    Error,
    CustomDropDown,
  },
  mixins: [storeMixin, alertMixin],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      skillSelected: null,
      collapseState: {},
    };
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    anyCollapseOpen() {
      return Object.values(this.collapseState).some(Boolean);
    },
    availableSkills() {
      const selectedIds = new Set((this.model.skills || []).map((s) => s.id));

      return (this.model.pendingSkills || []).filter(
        (skill) => !selectedIds.has(skill.id)
      );
    },
  },
  watch: {
    'model.skills': {
      immediate: true,
      handler(skills) {
        const nextState = {};

        (skills || []).forEach((item) => {
          nextState[item.id] =
            typeof this.collapseState[item.id] === 'boolean'
              ? this.collapseState[item.id]
              : false;
        });

        this.collapseState = nextState;
      },
    },
  },
  methods: {
    isEmpty(value) {
      return value === null || value === undefined || value === '';
    },
    updateCollapseState(id, value) {
      this.$set(this.collapseState, id, value);
    },
    remove(item) {
      const index = this.model.skills.findIndex(
        (skill) => skill.id === item.id
      );

      if (index !== -1) this.model.skills.splice(index, 1);
    },
    expandAll(open) {
      const nextState = {};

      (this.model.skills || []).forEach((item) => {
        nextState[item.id] = open;
      });

      this.collapseState = nextState;
    },
    addSkill() {
      if (!this.skillSelected) return;

      this.model.skills = [...this.model.skills, this.skillSelected];
      this.skillSelected = null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
